<template>
  <div :style="indent" >
    <template v-if="isMethodGroup">
      <fieldset>
        <div v-for="(field, index) in method" :key="'verification-field-' + depth.toString() + '-' + index.toString()">
          <div v-if="index > 0 && !hasAnyFieldValue" class="field-or-separator">
            <hr />
            <span>or</span>
          </div>
          <VerificationField
            v-if="showMethod(field)"
            :session="session"
            :method="field"
            :value="fields"
            :placeholders="placeholders"
          ></VerificationField>
        </div>
      </fieldset>
    </template>
    <fieldset v-else>
      <div class="fields mt-0 mob-verfi">
        <div v-if="isFirstName" class="pt-0 first-name">
          <div class="customer-match-formgroup">
            <label for="first_name" class="text-capitalize">First Name</label>
            <b-form-group label-for="first_name">
              <div data-for="first_name" class="placeholder-label">First Name</div>
              <b-form-input id="first_name" type="text" :value="fields.first_name"
                            :placeholder="placeholders.first_name" @input="updateData('first_name', $event)"
                            class="customer form-input-height" :required="isFieldRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-if="isLastName" class="pt-0 second-name">
          <div class="customer-match-formgroup">
            <label for="last_name" class="text-capitalize">Last Name</label>
            <b-form-group label-for="last_name">
              <div data-for="last_name" class="placeholder-label">Last Name</div>
              <b-form-input id="last_name" type="text" :value="fields.last_name" :placeholder="placeholders.last_name"
                            @input="updateData('last_name', $event)" class="customer form-input-height"
                            :required="isFieldRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-if="isFullAddress">
          <div class="customer-match-formgroup">
            <label for="address" class="text-capitalize">Address</label>
            <b-form-group label-for="address">
              <div data-for="address" class="placeholder-label">Address</div>
              <b-form-input id="address" type="text" :value="fields.address" :placeholder="placeholders.address"
                            @input="updateData('address', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
            <label for="city" class="text-capitalize mt-1">City</label>
            <b-form-group label-for="city">
              <div data-for="city" class="placeholder-label">City</div>
              <b-form-input id="city" type="text" :value="fields.city" :placeholder="placeholders.city"
                            @input="updateData('city', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
            <label for="country" class="text-capitalize mt-1">Country</label>
            <b-form-group label="" label-for="country">
              <div data-for="country" class="placeholder-label">Country</div>
              <b-form-select id="country" v-model="fields.country" :options="countries" placeholder="Country" @change="updateData('country', $event)" class="customer select"></b-form-select>
            </b-form-group>
            <label for="state" class="text-capitalize mt-1">State</label>
            <b-form-group label-for="state">
              <div data-for="state" class="placeholder-label">State</div>
              <b-form-select v-if="isUsOrCA()" id="state" v-model="fields.state" :options="getStates()"
                             :placeholder="placeholders.state" @input="updateData('state', $event)"
                             class="customer select form-input-height"></b-form-select>
              <b-form-input v-if="!isUsOrCA()" id="state" type="text" :value="fields.state" :placeholder="placeholders.state"
                            @input="updateData('state', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
            <label for="zip" class="text-capitalize mt-1">Zip</label>
            <b-form-group label-for="zip">
              <div data-for="zip" class="placeholder-label">Zip</div>
              <b-form-input id="zip" type="text" :formatter="zipFormat" :value="fields.zip" :placeholder="placeholders.zip"
                            @input="updateData('zip', $event)" class="customer form-input-height"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <template v-else>
          <div v-if="isStreet">
            <div class="customer-match-formgroup">
              <label for="address" class="text-capitalize">Address</label>
              <b-form-group label-for="address">
                <div data-for="address" class="placeholder-label">Address</div>
                <b-form-input id="address" type="text" :title="getStreetTitle" :value="fields.address"
                              :placeholder="placeholders.address" @input="updateData('address', $event)"
                              class="customer form-input-height" :required="isFieldRequired"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div v-if="isZip">
            <div class="customer-match-formgroup">
              <label for="zip" class="text-capitalize">Zip</label>
              <b-form-group label-for="zip">
                <div data-for="zip" class="placeholder-label">Zip</div>
                <b-form-input id="zip" type="text" :title="getZipTitle" :value="fields.zip"
                              :placeholder="placeholders.zip" @input="updateData('zip', $event)"
                              class="customer form-input-height" :required="isFieldRequired"></b-form-input>
              </b-form-group>
            </div>
          </div>
        </template>
        <div v-if="isEmail">
          <div class="customer-match-formgroup">
            <label for="email" class="text-capitalize">Email</label>
            <b-form-group label-for="email">
              <div data-for="email" class="placeholder-label">Email</div>
              <b-form-input id="email" type="email" :value="fields.email" placeholder="example@gmail.com"
                            @input="updateData('email', $event)" class="customer form-input-height"
              :required="isFieldRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div v-if="isPhone">
          <div class="customer-match-formgroup">
            <label for="phone" class="text-capitalize">Phone Number</label>
            <b-form-group label-for="phone">
              <div data-for="phone" class="placeholder-label">Phone</div>
              <b-form-input id="phone" type="tel" :value="fields.phone" placeholder="555-555-5555"
                            @input="updateData('phone', $event)" class="customer form-input-height"
              :required="isFieldRequired"></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {formatZipField, getCountryStates, isCountryUSOrCA, getCountries} from '@/utils'

const VerificationMethod = Object.freeze({
  FullName: 1,
  LastName: 2,
  Street: 3,
  Zip: 4,
  Address: 5,
  BillingStreet: 6,
  BillingZip: 7,
  BillingAddress: 8,
  Phone: 1000,
  PartialPhone: 1001,
  Email: 1002,
  PartialEmail: 1003
})

const VerificationMethodFields = Object.freeze({
  [VerificationMethod.FullName]: ['first_name', 'last_name'],
  [VerificationMethod.LastName]: ['last_name'],
  [VerificationMethod.Street]: ['address'],
  [VerificationMethod.Zip]: ['zip'],
  [VerificationMethod.Address]: ['address', 'city', 'state', 'zip', 'country'],
  [VerificationMethod.BillingStreet]: ['address'],
  [VerificationMethod.BillingZip]: ['zip'],
  [VerificationMethod.BillingAddress]: ['address', 'city', 'state', 'zip', 'country'],
  [VerificationMethod.Phone]: ['phone'],
  [VerificationMethod.PartialPhone]: ['phone'],
  [VerificationMethod.Email]: ['email'],
  [VerificationMethod.PartialEmail]: ['email']
})

export default {
  name: 'VerificationField',
  props: {
    session: Object,
    method: [Number, Array],
    depth: {
      type: Number,
      default: function() {
        return 0
      }
    },
    allFieldsRequired: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    value: {
      type: Object,
      default: function() {
        return {
          first_name: null,
          last_name: null,
          address: null,
          city: null,
          state: null,
          zip: null,
          phone: null,
          email: null,
          country: 'US'
        }
      }
    },
    placeholders: Object
  },
  data: function() {
    return {
      fields: Object.assign({}, this.value)
    }
  },
  computed: {
    ...mapState(['isIE', 'campaign']),
    countries() {
      return [{value: null, text: 'Country'}, ...getCountries(this.session)]
    },
    isMethodGroup: function() {
      return this.method && typeof this.method === 'object'
    },
    isFirstName: function() {
      return this.method === VerificationMethod.FullName
    },
    isLastName: function() {
      return this.method === VerificationMethod.LastName || this.method === VerificationMethod.FullName
    },
    isStreet: function() {
      return this.method === VerificationMethod.BillingStreet || this.method === VerificationMethod.BillingAddress ||
        this.method === VerificationMethod.Street || this.method === VerificationMethod.Address
    },
    isFullAddress: function() {
      return this.method === VerificationMethod.BillingAddress || this.method === VerificationMethod.Address
    },
    isZip: function() {
      return this.method === VerificationMethod.BillingZip || this.method === VerificationMethod.BillingAddress ||
        this.method === VerificationMethod.Zip || this.method === VerificationMethod.Address
    },
    isBilling: function() {
      return this.method === VerificationMethod.BillingZip || this.method === VerificationMethod.BillingAddress ||
        this.method === VerificationMethod.BillingStreet
    },
    isEmail: function() {
      return this.method === VerificationMethod.Email || this.method === VerificationMethod.PartialEmail
    },
    isPhone: function() {
      return this.method === VerificationMethod.Phone || this.method === VerificationMethod.PartialPhone
    },
    getStreetLabel: function() {
      return this.isBilling ? 'Billing Street:' : 'Street:'
    },
    getStreetTitle: function() {
      return this.isBilling ? 'House number and street of your billing address'
        : 'House number and street of either your billing or shipping address'
    },
    getZipLabel: function() {
      return this.isBilling ? 'Billing Zip/Postal Code:' : 'Zip/Postal Code:'
    },
    getZipTitle: function() {
      return this.isBilling ? 'Zip/Postal code of your billing address'
        : 'Zip/Postal code of either your billing or shipping address'
    },
    indent: function() {
      return { transform: `translate(${this.depth * 50}px)` }
    },
    isFieldRequired: function() {
      return this.allFieldsRequired ||
        (Object.values(this.fields).every(v => !v) && Object.values(this.value).every(v => !v))
    },
    hasAnyFieldValue: function() {
      return Object.values(this.fields).some(v => v)
    }
  },
  methods: {
    hasFieldValue: function(method) {
      if (typeof method === 'object') {
        return Object.values(method).some(m => this.hasFieldValue(m))
      }
      const fields = VerificationMethodFields[method] || []
      for (const field of fields) {
        if (this.fields[field]) {
          return true
        }
      }
      return false
    },
    hasAnyOtherFieldValue: function(method) {
      if (this.isMethodGroup) {
        for (const m of this.method) {
          if (m !== method && this.hasFieldValue(m)) {
            return true
          }
        }
        return false
      }
    },
    showMethod: function(method) {
      return !this.hasAnyOtherFieldValue(method)
    },
    updateData: function(field, val) {
      this.fields[field] = val
      this.$parent.updateData(field, val)

      if (field === 'country') {
        this.fields.state = ''
        this.fields.zip = ''
      }
    },
    getStates() {
      return getCountryStates(this.fields.country, this.campaign.blacklisted_states)
    },
    isUsOrCA() {
      return isCountryUSOrCA(this.fields.country)
    },
    zipFormat(value) {
      return formatZipField(value, this.fields.country)
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 425px) {
  label {
    margin-bottom: 5px;
  }
}
</style>
